import styled from "styled-components"
import { theme } from "Theme"

const Title = styled.h2`
  &.mb-0 {
    margin-bottom: 0;
  }
  color: inherit;
  font-weight: bold;
  max-width: ${theme.layout.blog};
`

export default Title
